export const Slot = ({ slotProps, error }) => {
  return (
    <div
      className={`relative w-14 h-14 text-[22.4px] flex items-center justify-center transition-all duration-300 border-[1.4px]  rounded-[5.6px] text-secondary-imed-60 font-semibold group-hover:border-secondary-imed-60 group-focus-within:border-secondary-imed-60 outline outline-0 outline-secondary-imed-60 ${
        slotProps.isActive || slotProps.char
          ? 'border-secondary-imed-60'
          : 'border-neutral-50'
      } ${error && 'border-error-dark'}`}>
      <div className='group-has-[input[data-input-otp-placeholder-shown]]:opacity-20'>
        {slotProps.char ?? slotProps.placeholderChar}
      </div>
      {(slotProps.hasFakeCaret || !slotProps.char) && <FakeCaret />}
    </div>
  )
}

function FakeCaret() {
  return <p className='text-neutral-50'>-</p>
}
